import { Renderer } from './renderer';

export const CommonErrorPage = Renderer;
